<template>
    <div class="patient-details-summary">

        <b-card-group deck class="mb-3">
            <b-card no-body>
                <b-card-header>
                    <h5>{{ $i18n.gt('HEADING_PATIENT_DETAILS') }}</h5>
                </b-card-header>
                <b-card-body>
                    <b-row :cols="$mq == 'sm' ? 1 : 2">
                        <b-col>
                            <patient-contact-methods-display :participant="participant">
                            </patient-contact-methods-display>
                        </b-col>
                        <b-col>
                            <b-row class="my-2">
                                <b-col cols="6">
                                    <label>{{ $i18n.gt('FIELD_PARTICIPANT_PLAN') }}</label>
                                </b-col>
                                <b-col cols="6">
                                    {{ participant.plan ? participant.plan.name : '' }}
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card-body>
                <b-card-footer>
                    <b-btn size="sm" variant="danger" class="btn-icon-text float-left"
                           @click="removePatient(participant)">
                        {{ $i18n.gt('LABEL_REMOVE_PATIENT') }}
                        <shs-icon name="delete"></shs-icon>
                    </b-btn>
                    <b-btn size="sm" variant="primary" class="btn-icon-text float-right"
                           :to="`/patient/update/id/${participant.id}`">
                        {{ $i18n.gt('LABEL_EDIT') }}
                        <shs-icon name="pencil"></shs-icon>
                    </b-btn>
                </b-card-footer>
            </b-card>
            <b-card no-body>
                <b-card-header>
                    <h5>{{ $i18n.gt('HEADING_PATIENT_ACTIVITY') }}</h5>
                </b-card-header>
                <b-card-body>
                    <b-row class="my-2" v-if="participant.lacksPassword">
                        <b-col>
                            <b-badge variant="warning" class="mb-1">
                                {{ $i18n.gt('BADGE_NO_PASSWORD') }}
                            </b-badge>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col>
                            <label>{{ $i18n.gt('FIELD_PARTICIPANT_PROFILE_UPDATED') }}</label>
                        </b-col>
                        <b-col>
                            <timestamp :date="participant.profile_updated"></timestamp>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col>
                            <label>{{ $i18n.gt('FIELD_PARTICIPANT_LAST_INVITATION') }}</label>
                        </b-col>
                        <b-col>
                            <timestamp :date="participant.last_invitation"></timestamp>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col>
                            <label>{{ $i18n.gt('LABEL_NEXT_APPOINTMENT') }}</label>
                        </b-col>
                        <b-col>
                            <patient-appointment :provider="provider">
                            </patient-appointment>
                        </b-col>
                    </b-row>
                </b-card-body>
                <b-card-footer>
                    <message-send-modal class="float-right"
                                        :participant-id="participantId">
                    </message-send-modal>
                    <emr-appointments-modal v-if="emrReadEnabled && participant.emr_id"
                                             class="float-right mr-2"
                                             :participant-id="participantId">
                    </emr-appointments-modal>
                </b-card-footer>
            </b-card>
        </b-card-group>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->
<script>
import * as _ from 'lodash'
import PractitionerPatientMixin from '@/providers/PractitionerPatientMixin'
import Vue from "vue";

export default {
    name: 'PatientDetailsSummary',
    mixins: [PractitionerPatientMixin],
    props: {
        participantId: Number
    },
    data() {
        return {
            sendingInvitations: false,
            emrReadEnabled: false,
        }
    },
    computed: {
        appointment: {
            get() {
                return this.provider ? this.provider.appointment : {} // see PatientMixin
            },
            set(val) {
                this.provider.appointment = val
            }
        }
    },
    mounted() {
        this.$api.emrScope(this, {
            practice: this.$user.practitionerPracticeId()
        })
            .then((scope) => {
                if (scope) {
                    this.emrReadEnabled = scope.includes('appointment.read')
                }
            })
    },
    methods: {
        async removePatient() {
            const ok = await this.$bvModal.msgBoxConfirm(this.$i18n.gt('MESSAGE_CONFIRM_REMOVE_PATIENT'))
            if (ok) {
                _.each(this.participant.providers, (provider) => {
                    if (provider.practice_id === this.$user.practitionerPracticeId()) {
                        this.$api.deleteItem(this, 'provider', provider)
                            .then((response) => {
                                this.$toasted.show('Patient removed', {duration: 3000})
                                this.loadParticipant(true) // refresh providers
                                this.$router.replace('/')
                                this.$root.$emit('bv::refresh::table', 'patient-table')
                            })
                    }
                })
            }
        }
    },
}
</script>
